<p>theme-option-elements-chart-gauge-shadow-size works!</p>
